module.exports = __webpack_public_path__ + "static/media/Flaticon.ff5f339c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flaticons/Flaticon.woff
// module id = 774
// module chunks = 0